function NotificationsLoader() {
  return (
    <>
      <div className="my-2 flex w-full items-center gap-2">
        <div className="mb-2 h-12 w-12 animate-pulse rounded-lg bg-gray-400" />
        <div>
          <div className="mb-2 h-4 w-72 animate-pulse rounded-md bg-gray-400" />
          <div className="mb-2 h-4 w-12 animate-pulse rounded-md bg-gray-400" />
        </div>
      </div>
    </>
  );
}

export default NotificationsLoader;
